import React, { useState } from "react";
import { Container, Nav, Navbar, Row, Col } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import Marquee from "react-fast-marquee";


const AppBar = () => {
  const location = useLocation(); // Get the current URL path

  // Check if the current path includes 'review'
  const isReviewPage = location.pathname.includes("review");
  
  return (
    <>
      <>
        <div className="mark-bg">
          <Container fluid>
            <Row>
              <Col lg="12" className="py-2">
                <Marquee
                  pauseOnHover={true}
                  direction="left"
                  speed={50}
                  delay={2}
                >
                  Whatsapp : +91 90251 48394 | Alter No : +91 87545 51707 |
                  Email : office.zentexus@gmail.com
                </Marquee>
              </Col>
            </Row>
          </Container>
        </div>
      </>
      <>
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container>
            <Navbar.Brand href="#home">
              <div className="logo">
                <img
                  src={require("../assets/images/storelogo.png")}
                  className="img-fluid"
                  alt="product name"
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto text-center">
                <Nav.Link as={NavLink} exact to={"/"} activeClassName="active">
                  Products
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  exact
                  to={"/paymentinformation"}
                  activeClassName="active"
                >
                  Payment Information
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  exact
                  to={"/safetytips"}
                  activeClassName="active"
                >
                  Safety Tips
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  exact
                  to={"/contactus"}
                  activeClassName="active"
                >
                  Contact Us
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  exact
                  to={"/chitfund"}
                  activeClassName="active"
                >
                  chit fund
                </Nav.Link>
              {isReviewPage && (
                <Nav.Link as={NavLink} exact to={"/review"} activeClassName="active">
                  Review
                </Nav.Link>
              )}
              </Nav>
              <Nav.Link
                as={NavLink}
                exact
                to={"/"}
                activeClassName="active"
                className="text-center estimate"
              >
                Estimate Now !!!
              </Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        
      </>
    </>
  );
};

export default AppBar;
